import { IColumns } from '../../../../../../components/Dashboard/TableSmall'
import { IColumns as IColumnsAll } from '../../../../../../components/Dashboard/Table/TableTypes'

export enum RiskLevel {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export interface IData {
  request: string
  columns: IColumns[]
}

export interface IDataAll {
  request: string
  columns: IColumnsAll[]
}

export const data: IData = {
  request: 'trades-history',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'type',
      label: 'ACTION',
    },
    {
      id: 'amount',
      label: 'NOTIONAL',
    },
    {
      id: 'quantity',
      label: 'AMOUNT',
    },
    {
      id: 'timestamp',
      label: 'DATE',
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      format: (value: string) => {
        const newDate = new Date(value)
        return newDate.toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
      },
    },
  ],
}

export const dataByUser: IDataAll = {
  request: 'trades-history',
  columns: [
    {
      id: 'timestamp',
      label: 'DATE',
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      format: (value: string) => {
        const newDate = new Date(value)
        return newDate.toLocaleString('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })
      },
    },
    {
      id: 'type',
      label: 'MARKET TYPE',
    },
    {
      id: 'price',
      label: 'PRICE',
      format: (value: number) => `$${value}`,
    },
    {
      id: 'quantity',
      label: 'QTY',
    },
    {
      id: 'amount',
      label: 'NOTIONAL',
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'status',
      label: 'STATUS',
    },
    {
      id: 'pair',
      label: 'PAIR',
    },
  ],
}

export const dataAll: IDataAll = {
  request: 'trades-history',
  columns: [
    {
      id: 'timestamp',
      label: 'DATE',
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      format: (value: string) => {
        const newDate = new Date(value)
        return newDate.toLocaleString('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })
      },
    },
    {
      id: 'pair',
      label: 'PAIR',
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'type',
      label: 'ACTION',
    },
    {
      id: 'price',
      label: 'PRICE',
      format: (value: number) => `$${value}`,
    },
    {
      id: 'quantity',
      label: 'QTY',
    },
    {
      id: 'amount',
      label: 'NOTIONAL',
    },
    {
      id: 'status',
      label: 'STATUS',
    },
  ],
}
